import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';

interface CheckoutProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Protected route for checkout that requires:
 * 1. User authentication
 * 
 * Note: Empty cart handling is done within the CheckoutPage component itself
 */
const CheckoutProtectedRoute: React.FC<CheckoutProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();

  // Show loading state while checking authentication
  if (authLoading) {
    return (
      <div className="flex justify-center items-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Redirect to home if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Render protected content if authenticated
  return <>{children}</>;
};

export default CheckoutProtectedRoute;

